import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { MatAutocompleteSelectedEvent } from "@angular/material/autocomplete";
import { debounceTime, finalize, switchMap, tap } from "rxjs/operators";
import { Airport, AirportAutocompleteSearchService } from "./airport-autocomplete-search.service";

@Component({
    selector: "app-airport-autocomplete-search",
    templateUrl: "./airport-autocomplete-search.component.html",
    styleUrls: ["./airport-autocomplete-search.component.scss"],
    standalone: false,
})
export class AirportAutocompleteSearchComponent implements OnInit {
    @Input() appearanceType = "outline";

    @Input() label = "FLIGHTS.UPDATE.departurePlace";

    @Input() placeholder = "FLIGHTS.UPDATE.departurePlace";

    @Input() formGroupElement: FormGroup;

    @Input() controlName: string;

    // tslint:disable-next-line:no-output-on-prefix
    @Output() onAirportOptionSelectedChange = new EventEmitter<number>();

    public departureIsLoading = false;
    public filteredDepartureAirportOptions: Airport[];

    _optionClicked = false;

    constructor(private _airportAutocompleteSearchService: AirportAutocompleteSearchService) {}

    ngOnInit(): void {
        this.formGroupElement
            .get(this.controlName)
            .valueChanges.pipe(
                debounceTime(300),
                switchMap((value) => this._airportAutocompleteSearchService.searchAirports({ name: value }).pipe(finalize(() => (this.departureIsLoading = false)))),
            )
            .subscribe((airports) => {
                if (!this._optionClicked) {
                    this.onAirportOptionSelectedChange.emit(null);
                }
                this.filteredDepartureAirportOptions = airports;
                this._optionClicked = false;
            });
    }

    onAirportOptionSelected(event: MatAutocompleteSelectedEvent) {
        const object = event.option.value as Airport;
        let valueObject = {};
        const dash = object.code ? "-" : "";
        const code = object.code ? object.code : "";
        if (object) {
            if (this.controlName === "departurePlace") {
                valueObject = { departurePlace: object.city + dash + code, departureId: object.id };
            } else {
                valueObject = { arrivalPlace: object.city + dash + code, arrivalId: object.id };
            }
            this.formGroupElement.get(this.controlName).setValue(object.city + dash + code, { emitEvent: false });
            this.onAirportOptionSelectedChange.emit(object.id);
            this._optionClicked = true;
        }
    }
}
